import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { QuotationAccessoriesComponent } from '../quotation-accessories.component';
import { AccessoryInsert } from '../../../../shared/models/quotation-model/catalogs/accessory-insert.model';
import { AccessoryQuotationUpdate } from '../../../../shared/models/quotation-model/main/accessory-quotation-update.model';
import { QuotationService } from '../../../../shared/services/quotation/quotation.service';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatSelect, MatOption } from '@angular/material/select';
import { MatCheckbox } from '@angular/material/checkbox';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-accessories-other',
  templateUrl: './accessories-other.component.html',
  styleUrls: ['./accessories-other.component.scss'],
  imports: [
    MatFormField,
    MatSelect,
    MatLabel,
    MatOption,
    MatCheckbox,
    TranslateModule,
    ReactiveFormsModule,
  ],
})
export class AccessoriesOtherComponent implements OnInit {
  otherAccesoryGroup!: FormGroup;
  accessoryInsert!: AccessoryInsert;

  constructor(
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<QuotationAccessoriesComponent>,
    @Inject(MAT_DIALOG_DATA) public obj: any,
    @Inject(MAT_DIALOG_DATA) public additionalId: any,
    private quotationService: QuotationService,
  ) {}

  ngOnInit() {
    this.otherAccesoryGroup = this.formBuilder.group({
      accessoryDescription: [''],
      cost: [''],
      isInIncome: [''],
      isFinanced: [''],
    });
  }

  updateAccesory() {
    var isInComeVar = 0;
    if (this.otherAccesoryGroup.get('isInIncome')!.value) {
      isInComeVar = 1;
    } else {
      isInComeVar = 0;
    }
    if (!this.otherAccesoryGroup.invalid) {
      const updateAccessoryItem: AccessoryQuotationUpdate = {
        quotationId: this.obj.quotationId,
        accessoryId: this.additionalId.additionalId,
        accessoryDescription: this.otherAccesoryGroup.get('accessoryDescription')!.value,
        cost: this.otherAccesoryGroup.get('cost')!.value,
        isInIncome: isInComeVar,
        isFinanced: this.otherAccesoryGroup.get('isFinanced')!.value,
      };

      this.quotationService.updateAccessory(updateAccessoryItem).subscribe((response) => {
        this.dialogRef.close();
      });
    }
  }

  keyPressNumbersWithDecimal(event: KeyboardEvent) {
    var charCode = event.which ? event.which : event.keyCode;
    if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    }
    return true;
  }
}
